import { osMapPrintStore } from "../store";
import { updateStore } from "./updateStore";

export const abortOsMapPrintRequest = () => {
  if (!osMapPrintStore.activeRequestAbort) return;
  osMapPrintStore.activeRequestAbort();
  updateStore({
    activeRequestAbort: null,
  });
};
